import React, { Component } from 'react'
import InputMask from 'react-input-mask'
import { Label } from 'components/UI/Label'
import { Tooltip } from 'components/UI/Tooltip'
import { dateMaskConfig, DEFAULT_DATE_FORMAT } from 'utils/dateFormats'
import { HelperText, Input, Wrapper, LabelWrap, TooltipWrap } from './styles'

export interface TextInputProps {
  id?: string
  type?: 'text' | 'password' | 'submit' | 'button' | 'date'
  name: string
  value: string
  label?: string
  placeholder?: string
  maskConfig?: object
  helperText?: string
  tooltipText?: string
  errorLabel?: string
  disabled?: boolean
  readOnly?: boolean
  maxLength?: number
  handleChange?: (name: string, value: string) => void
  // onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}
// onBlur?: React.FocusEvent<HTMLInputElement>
// onFocus?: React.FocusEvent<HTMLInputElement>

export interface TextInputState {
  value: string
  prevPropsValue: string
}

class TextInput extends Component<TextInputProps, TextInputState> {
  public static defaultProps = {
    name: '',
    type: 'text',
    value: '',
    placeholder: '',
    helperText: '',
    tooltipText: '',
    errorLabel: '',
    label: '',
    handleChange: () => {},
    // onBlur: (e: any) => {},
    // onFocus: (e: any) => {},
    disabled: false,
    readOnly: false
  }

  static getDerivedStateFromProps(
    props: TextInputProps,
    state: TextInputState
  ) {
    if (props.value !== state.prevPropsValue) {
      return {
        prevPropsValue: props.value,
        value: props.value
      }
    }
    return null
  }

  constructor(props: TextInputProps) {
    super(props)

    this.state = {
      value: props.value,
      prevPropsValue: ''
    }
  }

  // onChange = (e: React.ChangeEvent<HTMLInputElement>, value: string): void => {
  //   const key = e.currentTarget.name;
  //
  //   if (Object.keys(this.state).includes(key)) {
  //     this.setState({[key]: value } as Pick<State, keyof State>);
  //   }
  // }

  onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { handleChange } = this.props
    const { name, value } = e.currentTarget

    this.setState({ value }, () => {
      if (handleChange) {
        handleChange(name, value)
      }
    })
  }

  renderInput() {
    const {
      label,
      name,
      type,
      placeholder,
      disabled,
      readOnly,
      maskConfig,
      ...rest
    } = this.props

    const { value } = this.state

    if (maskConfig || type === 'date') {
      const mask = !maskConfig ? dateMaskConfig : maskConfig
      return (
        // @ts-ignore
        <InputMask
          {...mask}
          name={name}
          onChange={this.onChange}
          {...rest}
          value={value}
        >
          {(inputProps: any) => (
            // @ts-ignore
            <Input
              type={'text'}
              {...inputProps}
              {...rest}
              value={value}
              placeholder={placeholder ? placeholder : `Enter ${DEFAULT_DATE_FORMAT}`}
            />
          )}
        </InputMask>
      )
    }

    return (
      <Input
        {...rest}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onChange={this.onChange}
      />
    )
  }

  render() {
    const { id, label, helperText, tooltipText } = this.props

    // @ts-ignore
    return (
      <Wrapper>
        <LabelWrap>
          {!!label && (
            <div>
              <Label htmlFor={id}>{label}</Label>
            </div>
          )}
          {tooltipText && (
            <TooltipWrap>
              <Tooltip text={tooltipText} />
            </TooltipWrap>
          )}
        </LabelWrap>
        {this.renderInput()}
        {helperText && <HelperText>{helperText}</HelperText>}
      </Wrapper>
    )
  }
}

export default TextInput
